import React from 'react'
import shield from "../images/Shield.png";
export default function Footer() {
  return (
    <div className='footer'>
    <img src={shield}></img>
    <p>Your data is 100 % safe and secure</p>
</div>
  )
}
